import script from "./esAdmin.vue?vue&type=script&setup=true&lang=ts"
export * from "./esAdmin.vue?vue&type=script&setup=true&lang=ts"

import "./esAdmin.vue?vue&type=style&index=0&id=1252b105&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1252b105"]])

export default __exports__